import React from 'react';
import styled from 'styled-components';
import Notification from '../domain/Notification';

export const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary};
  margin: ${({ theme }) => theme.metrics.smallMargin}px;
`;

export const IconSpanWrapper = styled.span`
  vertical-align: middle;
  line-height: 40px;
  height: 40px;
  display: inline-block;
`;

export const Icon = styled.i`
  font-size: 40px;
`;

export const ContentWrapper = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
  flex: 2;
`;

export const Title = styled.div`
  padding: ${({ theme }) => theme.metrics.tinyMargin}px 0;
  margin-bottom: ${({ theme }) => theme.metrics.tinyMargin}px;
`;

export const Message = styled.div`
  font-size: 14px;
`;

export const Wrapper = styled.div`
  margin-left: -${({ theme }) => theme.metrics.smallMargin}px;

  display: flex;
  cursor: pointer;
`;

export type Props = {
  notification: Notification,
  actions?: any,
  t: any,
}

export default function NotificationContent(props: Props) {
  const { notification, t, actions } = props;

  return (
    <Wrapper>
      <ContentWrapper>
        <Title>{t(notification.title)}</Title>
        <Message>{t(notification.message)}</Message>
      </ContentWrapper>
      {actions}
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/common/modules/ui/components/NotificationContent.js